// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_O7s","tabsBox":"styles_tabsBox__1WMyR","createButton":"styles_createButton__3JRdw"};